// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2019 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-layer-data-sources-tab {
  display: flex;
  flex-direction: column;
}

.neuroglancer-layer-data-sources-container {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 0px;
  z-index: 1;
}

.neuroglancer-layer-data-source-url-input input.autocomplete-input {
  color: #fff;
}

.neuroglancer-layer-data-source-url-input input.autocomplete-hint {
  color: #aaa;
}

.neuroglancer-layer-data-source-url-input .autocomplete-dropdown {
  background-color: #333;
}

.neuroglancer-layer-data-sources-source-id {
  font-weight: bold;
}

.neuroglancer-layer-data-sources-source-id:not(:empty)::before {
  content: "[";
}

.neuroglancer-layer-data-sources-source-id:not(:empty)::after {
  content: "]";
}

.neuroglancer-layer-data-sources-source-id:not(:empty) {
  margin-right: 4px;
  color: #0ff;
}

.neuroglancer-layer-data-sources-source-type {
}

.neuroglancer-layer-data-sources-source-messages:empty {
  display: none;
}

.neuroglancer-layer-data-sources-source-messages {
  margin-top: 0px;
  list-style: none;
  padding-left: 0px;
}

li.neuroglancer-message {
  word-wrap: break-word;
  user-select: text;
}

li.neuroglancer-message-error {
  color: red;
}

li.neuroglancer-message-warning {
  color: yellow;
}

li.neuroglancer-message-info {
  color: #ccc;
}

.neuroglancer-layer-data-sources-source-default {
  display: block;
  margin-bottom: 4px;
}

.neuroglancer-layer-data-sources-info-line[data-is-active="false"] {
  text-decoration: solid line-through #caa;
}

.neuroglancer-layer-data-sources-tab-type-detection {
  position: sticky;
  bottom: 0px;
  background-color: #ff9;
  color: black;
  text-align: center;
  cursor: pointer;
}

.neuroglancer-layer-data-sources-tab-type-detection:hover {
  background-color: #ffc;
}

.neuroglancer-layer-data-sources-tab-type-detection-type {
  font-weight: bold;
}

.neuroglancer-layer-data-sources-tab .neuroglancer-progress {
  margin: 0px;
  list-style: none;
  padding: 0px;
}

.neuroglancer-layer-data-sources-tab .neuroglancer-progress > li {
  color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/ui/layer_data_sources_tab.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb","sourcesContent":["/**\n * @license\n * Copyright 2019 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-layer-data-sources-tab {\n  display: flex;\n  flex-direction: column;\n}\n\n.neuroglancer-layer-data-sources-container {\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 0px;\n  z-index: 1;\n}\n\n.neuroglancer-layer-data-source-url-input input.autocomplete-input {\n  color: #fff;\n}\n\n.neuroglancer-layer-data-source-url-input input.autocomplete-hint {\n  color: #aaa;\n}\n\n.neuroglancer-layer-data-source-url-input .autocomplete-dropdown {\n  background-color: #333;\n}\n\n.neuroglancer-layer-data-sources-source-id {\n  font-weight: bold;\n}\n\n.neuroglancer-layer-data-sources-source-id:not(:empty)::before {\n  content: \"[\";\n}\n\n.neuroglancer-layer-data-sources-source-id:not(:empty)::after {\n  content: \"]\";\n}\n\n.neuroglancer-layer-data-sources-source-id:not(:empty) {\n  margin-right: 4px;\n  color: #0ff;\n}\n\n.neuroglancer-layer-data-sources-source-type {\n}\n\n.neuroglancer-layer-data-sources-source-messages:empty {\n  display: none;\n}\n\n.neuroglancer-layer-data-sources-source-messages {\n  margin-top: 0px;\n  list-style: none;\n  padding-left: 0px;\n}\n\nli.neuroglancer-message {\n  word-wrap: break-word;\n  user-select: text;\n}\n\nli.neuroglancer-message-error {\n  color: red;\n}\n\nli.neuroglancer-message-warning {\n  color: yellow;\n}\n\nli.neuroglancer-message-info {\n  color: #ccc;\n}\n\n.neuroglancer-layer-data-sources-source-default {\n  display: block;\n  margin-bottom: 4px;\n}\n\n.neuroglancer-layer-data-sources-info-line[data-is-active=\"false\"] {\n  text-decoration: solid line-through #caa;\n}\n\n.neuroglancer-layer-data-sources-tab-type-detection {\n  position: sticky;\n  bottom: 0px;\n  background-color: #ff9;\n  color: black;\n  text-align: center;\n  cursor: pointer;\n}\n\n.neuroglancer-layer-data-sources-tab-type-detection:hover {\n  background-color: #ffc;\n}\n\n.neuroglancer-layer-data-sources-tab-type-detection-type {\n  font-weight: bold;\n}\n\n.neuroglancer-layer-data-sources-tab .neuroglancer-progress {\n  margin: 0px;\n  list-style: none;\n  padding: 0px;\n}\n\n.neuroglancer-layer-data-sources-tab .neuroglancer-progress > li {\n  color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
